/**
 * Pure helpers for the Vodia import report's checkboxes (ADR 0054): which
 * templates and phones are ticked, select-all, and the commit payload.
 */

export interface ImportSelection {
  templates: Set<string>;
  devices: Set<string>;
}

/** Everything ticked — the default after a dry run. */
export function selectAll(
  templateNames: string[],
  macs: string[],
): ImportSelection {
  return { templates: new Set(templateNames), devices: new Set(macs) };
}

/** Flip one key in one list. */
export function toggle(
  sel: ImportSelection,
  list: keyof ImportSelection,
  key: string,
): ImportSelection {
  const next = new Set(sel[list]);
  if (next.has(key)) next.delete(key);
  else next.add(key);
  return { ...sel, [list]: next };
}

/** Tick or untick a whole list. */
export function setAll(
  sel: ImportSelection,
  list: keyof ImportSelection,
  keys: string[],
  on: boolean,
): ImportSelection {
  return { ...sel, [list]: on ? new Set(keys) : new Set<string>() };
}

/** What the commit sends: explicit lists, so an empty list means "none". */
export function selectionPayload(sel: ImportSelection): {
  templates: string[];
  devices: string[];
} {
  return { templates: [...sel.templates], devices: [...sel.devices] };
}
